import { render, staticRenderFns } from "./ReservationFilters.vue?vue&type=template&id=6215ff16&"
import script from "./ReservationFilters.vue?vue&type=script&lang=js&"
export * from "./ReservationFilters.vue?vue&type=script&lang=js&"
import style0 from "./ReservationFilters.vue?vue&type=style&index=0&id=6215ff16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports